import { Directive } from "@angular/core";
import { NzInputGroupWhitSuffixOrPrefixDirective } from "ng-zorro-antd/input";

@Directive({
  selector: `ui-input-group[uiSuffix], ui-input-group[uiPrefix]`,
  standalone: true,
})
export class UiInputGroupWhitSuffixOrPrefixDirective extends NzInputGroupWhitSuffixOrPrefixDirective {}
